import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { dateTimeFormat } from "utils/format";
import { Button } from "reactstrap";
import { Trash } from "react-feather";

import { Cut } from "components/Cut";

import "./crossTable.scss";

export const CrossTable = ({ cross, remove, onSort, setSelected }) => {

  const tableColumns = [
    {
      dataField: "brand",
      text: "Бренд",
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "article",
      text: "Артикул",
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "brandAnalog",
      text: "Бренд",
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "articleAnalog",
      text: "Артикул",
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "analogueCode",
      text: "Код аналога",
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: () => {
        return { width: "18%" };
      }
    },
    {
      dataField: "createdAt",
      text: "Дата",
      formatter: (cell, row) => dateTimeFormat(cell),
      headerStyle: () => {
        return { width: "8%" };
      },
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      }
    },
    {
      dataField: "source",
      text: "Источник",
      headerStyle: () => {
        return { width: "7%" };
      },
      sort: true,
      onSort,
      sortFunc: () => {
        return false;
      }
    },
    {
      dataField: "file",
      text: "Файл",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "",
      text: "",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => <Button
        color="link"
        onClick={() => remove(row.id)}
      >
        <Trash color="red" size={20} />
      </Button>,
    }
  ];

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(cross.map((val) => val.id));
      }
    },
  };

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={cross}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        classes="pointer"
        selectRow={selectRow}
      />
    </>
  );
};
